import {
    setError,
    setEmailError,
    setFormValues,
    setIsPatchEditEmployeeSuccess,
    setResetEmailState,
    setIsEditEmployeeModalOpen,
    EditEmployeeModalInterface,
} from "../EditEmployeeModalSlice";
import { getResetEmailState } from "./getResetEmailState";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { Dispatch } from "redux";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { toast } from "react-toastify";

interface HandleEditEmployeeInterface {
    dispatch: Dispatch;
    patchEditEmployee: (params: {
        id: number;
        data: Record<string, unknown>;
    }) => { unwrap: () => Promise<unknown> };
    selectedEmployee?: EmployeeInterface;
    formValues: EditEmployeeModalInterface["formValues"];
}

export const handleEditEmployee = async (
    props: HandleEditEmployeeInterface,
): Promise<void> => {
    const { dispatch, formValues, patchEditEmployee, selectedEmployee } = props;

    if (!selectedEmployee) {
        return;
    }

    try {
        await patchEditEmployee({
            id: selectedEmployee.id,
            data: {
                insertion: formValues?.insertion,
                first_name: formValues?.firstName,
                last_name: formValues?.lastName,
                function_group_ids: formValues?.functionGroups.map(
                    (functionGroup) => functionGroup.selectedId,
                ),
                business_email: formValues?.businessEmail,
                private_email: formValues?.privateEmail,
                mobile_number: formValues?.telephoneNumber,
                new_email: formValues?.newEmail,
                date_of_birth: formValues?.dateOfBirth,
                place_of_birth: formValues?.placeOfBirth,
                establishment_id: selectedEmployee?.establishment.id,
            },
        }).unwrap();
        dispatch(setError(null)); // Clear any existing general error messages
        dispatch(setEmailError(null)); // Clear any existing email-specific error messages
        dispatch(setFormValues(null));
        dispatch(setIsPatchEditEmployeeSuccess(true));
        dispatch(setIsEditEmployeeModalOpen(false));
        dispatch(setResetEmailState(getResetEmailState())); // Reset email fields
        toast.info("Medewerker is gewijzigd");
    } catch (error) {
        const errorData = error as ErrorInterface;
        // Add null check to prevent "Cannot read properties of undefined (reading 'message')" error
        const errorMessage =
            errorData?.data?.message ||
            "Er is een fout opgetreden bij het wijzigen van de medewerker";
        dispatch(setError(errorMessage));
    }
};
